// @ts-nocheck
import { Plugin } from 'D:/CloudPatrolUI/Mayun.UI/node_modules/@umijs/runtime';

const plugin = new Plugin({
  validKeys: ['modifyClientRenderOpts','patchRoutes','rootContainer','render','onRouteChange','dva','getInitialState','initialStateConfig','locale','locale','request',],
});

export { plugin };
